import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';
import fareCalculator from '../services/fareCalculator';
import './RideHistory.css';

const RideHistory = ({ onClose }) => {
    const [rides, setRides] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadRideHistory();
    }, []);

    const loadRideHistory = async () => {
        try {
            setLoading(true);
            const response = await apiService.getRideHistory();
            
            if (response.success) {
                setRides(response.rides || []);
                setError(null);
            } else {
                setError('履歴の取得に失敗しました。');
            }
        } catch (err) {
            setError('履歴の取得に失敗しました。');
            console.error('Error loading ride history:', err);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('ja-JP', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const calculateTotalStats = () => {
        const completedRides = rides.filter(ride => ride.status === 'completed');
        const totalRides = completedRides.length;
        const totalDistance = completedRides.reduce((sum, ride) => sum + (ride.distance || 0), 0);
        const totalFare = completedRides.reduce((sum, ride) => sum + (ride.fare || 0), 0);
        const totalDuration = completedRides.reduce((sum, ride) => sum + (ride.duration || 0), 0);

        return {
            totalRides,
            totalDistance,
            totalFare,
            totalDuration
        };
    };

    const stats = calculateTotalStats();

    if (loading) {
        return (
            <div className="ride-history">
                <header className="history-header">
                    <h2>利用履歴</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </header>
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <div>読み込み中...</div>
                </div>
            </div>
        );
    }

    return (
        <div className="ride-history">
            <header className="history-header">
                <h2>利用履歴</h2>
                <button className="close-btn" onClick={onClose}>×</button>
            </header>

            {error && (
                <div className="error-message">
                    {error}
                </div>
            )}

            {rides.length > 0 && (
                <div className="stats-summary">
                    <div className="stat-item">
                        <div className="stat-label">総利用回数</div>
                        <div className="stat-value">{stats.totalRides}回</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">総距離</div>
                        <div className="stat-value">{fareCalculator.formatDistance(stats.totalDistance)}</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">総料金</div>
                        <div className="stat-value">{fareCalculator.formatFare(stats.totalFare)}</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-label">総時間</div>
                        <div className="stat-value">{fareCalculator.formatDuration(stats.totalDuration)}</div>
                    </div>
                </div>
            )}

            <div className="rides-list">
                {rides.length === 0 ? (
                    <div className="no-rides">
                        <div className="no-rides-icon">🚗</div>
                        <div>まだ利用履歴がありません</div>
                    </div>
                ) : (
                    rides.map((ride) => (
                        <div key={ride.id} className={`ride-item ${ride.status}`}>
                            <div className="ride-header">
                                <div className="ride-date">{formatDate(ride.createdAt)}</div>
                                <div className={`ride-status ${ride.status}`}>
                                    {ride.status === 'completed' ? '完了' : ride.status === 'active' ? '進行中' : '未完了'}
                                </div>
                            </div>
                            
                            <div className="ride-details">
                                <div className="detail-row">
                                    <span className="detail-label">料金:</span>
                                    <span className="detail-value fare">{fareCalculator.formatFare(ride.fare)}</span>
                                </div>
                                
                                <div className="detail-row">
                                    <span className="detail-label">距離:</span>
                                    <span className="detail-value">{fareCalculator.formatDistance(ride.distance || 0)}</span>
                                </div>
                                
                                {ride.duration && (
                                    <div className="detail-row">
                                        <span className="detail-label">時間:</span>
                                        <span className="detail-value">{fareCalculator.formatDuration(ride.duration)}</span>
                                    </div>
                                )}
                                
                                {ride.startTime && (
                                    <div className="detail-row">
                                        <span className="detail-label">開始:</span>
                                        <span className="detail-value">{formatDate(ride.startTime)}</span>
                                    </div>
                                )}
                                
                                {ride.endTime && (
                                    <div className="detail-row">
                                        <span className="detail-label">終了:</span>
                                        <span className="detail-value">{formatDate(ride.endTime)}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default RideHistory;